import {
  createStylesParams,
  StyleParamType,
  wixColorParam,
} from '@wix/tpa-settings';

export type ImageStylesParams = {
  coverImageCornerRadiusTopLeft: StyleParamType.Number;
  coverImageCornerRadiusTopRight: StyleParamType.Number;
  coverImageCornerRadiusBottomLeft: StyleParamType.Number;
  coverImageCornerRadiusBottomRight: StyleParamType.Number;
  coverImageCornerRadiusLinked: StyleParamType.Number;
  coverImageOpacity: StyleParamType.Number;
  coverImageBackgroundColor: StyleParamType.Color;

  sectionImageCornerRadiusTopLeft: StyleParamType.Number;
  sectionImageCornerRadiusTopRight: StyleParamType.Number;
  sectionImageCornerRadiusBottomLeft: StyleParamType.Number;
  sectionImageCornerRadiusBottomRight: StyleParamType.Number;
  sectionImageCornerRadiusLinked: StyleParamType.Number;
  sectionImageOpacity: StyleParamType.Number;
  sectionImageBackgroundColor: StyleParamType.Color;

  itemImageCornerRadiusTopLeft: StyleParamType.Number;
  itemImageCornerRadiusTopRight: StyleParamType.Number;
  itemImageCornerRadiusBottomLeft: StyleParamType.Number;
  itemImageCornerRadiusBottomRight: StyleParamType.Number;
  itemImageCornerRadiusLinked: StyleParamType.Number;
  itemImageOpacity: StyleParamType.Number;
  itemImageBackgroundColor: StyleParamType.Color;

  unsellableItemImageCornerRadiusTopLeft: StyleParamType.Number;
  unsellableItemImageCornerRadiusTopRight: StyleParamType.Number;
  unsellableItemImageCornerRadiusBottomLeft: StyleParamType.Number;
  unsellableItemImageCornerRadiusBottomRight: StyleParamType.Number;
  unsellableItemImageCornerRadiusLinked: StyleParamType.Number;
  unsellableItemImageOpacity: StyleParamType.Number;
  unsellableItemImageBackgroundColor: StyleParamType.Color;
};

export const imageStylesParams = createStylesParams<ImageStylesParams>({
  coverImageCornerRadiusTopLeft: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  coverImageCornerRadiusTopRight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  coverImageCornerRadiusBottomLeft: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  coverImageCornerRadiusBottomRight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  coverImageCornerRadiusLinked: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  coverImageOpacity: {
    type: StyleParamType.Number,
    getDefaultValue: () => 100,
  },
  coverImageBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 0.06),
  },

  sectionImageCornerRadiusTopLeft: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionImageCornerRadiusTopRight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionImageCornerRadiusBottomLeft: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionImageCornerRadiusBottomRight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionImageCornerRadiusLinked: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionImageOpacity: {
    type: StyleParamType.Number,
    getDefaultValue: () => 100,
  },
  sectionImageBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.06),
  },

  itemImageCornerRadiusTopLeft: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  itemImageCornerRadiusTopRight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  itemImageCornerRadiusBottomLeft: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  itemImageCornerRadiusBottomRight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  itemImageCornerRadiusLinked: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  itemImageOpacity: {
    type: StyleParamType.Number,
    getDefaultValue: () => 100,
  },
  itemImageBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.06),
  },

  unsellableItemImageCornerRadiusTopLeft: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  unsellableItemImageCornerRadiusTopRight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  unsellableItemImageCornerRadiusBottomLeft: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  unsellableItemImageCornerRadiusBottomRight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  unsellableItemImageCornerRadiusLinked: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  unsellableItemImageOpacity: {
    type: StyleParamType.Number,
    getDefaultValue: () => 100,
  },
  unsellableItemImageBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.06),
  },
});
